import styled from "styled-components";
import { gray, white } from "../styles/colors";
import { PRIVACY_POLICY_URL } from "../constants/links";

export function Footer() {
  const year = new Date().getFullYear();

  return (
    <Bar>
      <Inner>
        <Copy>© Vulcan Technology Collective LLC, {year}</Copy>
        <Links>
          <Link href="#pricing">Pricing</Link>
          <Link href={PRIVACY_POLICY_URL} target="_blank" rel="noopener">
            Privacy Policy
          </Link>
        </Links>
      </Inner>
    </Bar>
  );
}

const Bar = styled.footer({
  padding: "28px 24px",
  background: "#1a1a1a",
  color: white,
});

const Inner = styled.div({
  maxWidth: 1100,
  margin: "0 auto",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 16,
  flexWrap: "wrap",
});

const Copy = styled.p({
  margin: 0,
  fontSize: 13,
  color: gray,
});

const Links = styled.div({
  display: "flex",
  gap: 20,
});

const Link = styled.a({
  fontSize: 13,
  color: gray,
  transition: "color 0.2s ease",

  "&:hover": {
    color: white,
  },
});
